import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Views
import Home from './views/home';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<p>ERROR 404</p>} />
      </Routes>
    </Router>
  );
}

export default App;
